const StringUtils = {
    frameKey:"ABC-LogistiqUAE112244-react-key",
    iv:"MTYtYnl0ZS1maXhlZC1JVg==",
    taskAllocation: "Task Allocation",
    driverRepository: "Driver repository",
    locationRepository: "Location repository",
    unassignedTasks: "Unassigned",
    assignedTasks: "Assigned",
    completedTasks: "Completed",
    driverList: "Driver List",
    pickupLocation: "PICKUP LOCATION",
    pickupAddress: "PICKUP ADDRESS",
    destinationHub: "DESTINATION HUB",
    visitTime: "VISIT TIME",
    taskId: "TASK ID",
    tasks: "TASKS",
    createdOn: "CREATED ON",
    driver: "DRIVER",
    action: "Action",
    assign: "Assign",
    assigning: "Assigning...",
    driverName: "Driver Name",
    lastUpdatedAt: "LAST UPDATED AT",
    driverAssignmentIsNotYetDone: 'Driver assignment is not yet done. Kindly check the unassigned tasks list and start assigning drivers.',
    noCompleteTasks: 'No Complete Tasks',
    noAssignedTasks: 'No Assigned Tasks',
    noUnassignedTasks: 'No Unassigned Tasks',
    search: "search",
    status: "Status",
    assignedLocations: 'Assigned Location',
    unassign: 'Unassign',
    unassigning: 'Unassigning...',
    areYouSureYouWantToContinue: 'Are you sure you want to continue?',
    thisActionWillMoveTheOrderToUnassignedTask: 'This action will move the order to unassigned task',
    unassignedTaskFrom: 'Unassigned task from',
    pickupOrders: 'Pickup Orders',
    orderId: 'ORDER ID',
    awb: 'AWB',
    concept: 'Concept',
    boxCount: 'Box Count',
    boxId: 'Box Id',
    orderBookedAt: 'Order Booked At',
    addedToTask: 'Added To Task',
    location: 'Location',
    taskType: 'Task Type',
    pickUp: 'Pick Up',
    rtoOrders: 'Rto Orders',
    rto: 'RTO',
    returnOrders: 'Returned Orders',
    return: 'Return',
    itemQuantity: 'Items QTY',
    locations: "Locations",
    orders: "Orders",
    pickup: "Pickup",
    searchAwb: "Search AWB",
    addToExisting: "Add To Existing",
    createTask: "Create Task",
    pleaseSelectMinimumOneOrder: "please select minimum one order",
    maximum250OrdersCanBeSearchedAtATime: "Maximum 250 orders can be searched at a time",
    pleaseEnterLocationAddress: "Please enter Location Address",
    phoneNumberIsRequired: "Phone number is required.",
    phoneNumberShouldHaveEightDigits: "Phone number should have 8 digits.",
    pleaseEnterLatitude: "Please enter latitude.",
    invalidLatitude: "Invalid latitude.",
    pleaseEnterLongitude: "Please enter longitude",
    invalidLongitude: "Invalid longitude",
    pleaseEnterEmail: "Please enter email",
    invalidEmail: "Invalid Email",
    invalidHour: "Invalid hour",
    invalidMinute: "Invalid Minute",
    pleaseEnterValidHour: "Please enter valid hour",
    pleaseEnterValidMinute: "Please enter valid minute",
    clearAll:"Clear All",
    submit:"Submit",
    dateRange:"Date Range",
    specificDate:"Specific Date",
    uptoDate:"Up to Date",
    direction:"DIRECTION",
    numberOfBoxes:"# BOX COUNT",
    vendorName:"VENDOR NAME",
    vendor:"Vendor",
    contactNo:"CONTACT NO.",
    city:"CITY",
    area:"AREA",
    address:"ADDRESS",
    active:"Active",
    assetId:"ASSET ID",
    defaultSelectLabel:"Select...",
    searchLabel:"Search...",
    selectAll:"Select All",
    noResultFound:"No results found",
    warehouse:"Warehouse",
    downloadFileFailed:"Download file failed: ",
    downloadSuccess:"File downloaded successfully",
    downloadFailed:"Download failed",
    task:"Task",
    taskAge: "Task Age",
    days: "day(s)",
}
export default StringUtils;